module.exports = __webpack_public_path__ + "assets/webgl/360_vignes.jpg.dxt.7e28e92b.ktx";